import { useCallback } from 'react';
import { OnSeek } from './types';
import {
  useMessageDispatch,
  UseMessageDispatchProps,
} from './useEddyMessaging';
import useMessageHandler from './useEddyMessaging/useMessageHandler';

type SeekMessageData = {
  type: 'seek';
  reason: 'user' | 'deletion' | 'programmatic';
  millis: number;
};

export type UseSeekMessagingProps = Pick<UseMessageDispatchProps, 'iframe'> & {
  onSeek?: OnSeek;
};

export default function useSeekMessaging({
  iframe,
  onSeek,
}: UseSeekMessagingProps) {
  const dispatch = useMessageDispatch({ iframe });

  const seek = useCallback(
    (millis: number) => {
      dispatch({
        type: 'seek',
        millis,
      });
    },
    [dispatch],
  );

  useMessageHandler<SeekMessageData>(
    e => {
      if (e.data.type === 'seek' && e.data.reason !== 'deletion') {
        onSeek?.(e.data.millis);
      }
    },
    { iframe },
  );

  return { seek };
}
